module.exports = __webpack_public_path__ + "media/images/wines/verdejo/bottle-f89e6158c1d19dea5e81c212d6538f73.png";